import { SrfSwipeableMeteoWeek } from './srf-swipeable-meteo-week';
import { readyToInteract } from './srf-meteo-helpers';
import { TRACK_INTERACTION, triggerEvent } from '@fec/assets/js/utils/event';
import ClientStorage from '@fec/frontend/foundation/client/storage';
import lottie from 'lottie-web';

const WARNING_INTERVAL = 60 * 1000;
const ANIMATED_WEATHER_ICONS_LOCALSTORAGE_KEY =
  'srf:meteo:animatedWeatherIconsEnabled';

export function init() {
  let $el = $('.meteo--home');
  if ($el.length) {
    new MeteoHome($el);
  }

  const $surfChart = $('.js-surf-chart');
  if ($surfChart.length) {
    readyToInteract();
  }
}

export class MeteoHome {
  constructor(element) {
    this.$element = $(element);
    this.isTeaser = this.$element.hasClass('meteo--teaser');

    this.$animationEnabledSwitch = this.$element.find(
      '#meteo-icon-animation-switch',
    );
    this.animatedWeatherIconObserver = null;

    /**
     * @type {Object.<string, lottie.Animation>}
     */
    this.lottieInstances = {};
    this.animatedWeatherIconSelectors = this.getAnimatedWeatherIconSelectors();
    this.staticWeatherIconSelectors = this.getStaticWeatherIconSelectors();

    this.showMapImage();
    this.registerListeners();

    this.initAnimatedWeatherIcons();
    readyToInteract();
    this.showWarnings();

    setInterval(() => {
      this.showWarnings();
    }, WARNING_INTERVAL);

    if ($('.weather-week--home').length) {
      new SrfSwipeableMeteoWeek($('.weather-week'), this.showDay.bind(this));
    }
  }

  // for performance optimization srf home, custom because of custom markup (not a SRF Responsive Image as usual)
  showMapImage() {
    $('.meteo-locations__img--lazyload').each((i, image) => {
      let $image = $(image);
      if ($image.data('srcset')) {
        $image.attr('srcset', $image.data('srcset'));
      } else if ($image.data('src')) {
        $image.attr('src', $image.data('src'));
      }
    });
  }

  registerListeners() {
    this.$animationEnabledSwitch.on('change', (event) => {
      this.onAnimationsToggled(event.target.checked);
    });

    // Support optional "enter" key press to toggle the animation switch
    // for better accessibility: https://www.w3.org/WAI/ARIA/apg/patterns/switch/
    this.$animationEnabledSwitch.on('keyup', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        this.$animationEnabledSwitch.click();
      }
    });

    this.animatedWeatherIconObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) =>
          this.onAnimatedWeatherIconVisibilityChanged(entry),
        );
      },
      {
        threshold: 0,
      },
    );
  }

  getAnimationEnabledStateFromLocalStorage() {
    return (
      ClientStorage.getItem(
        ANIMATED_WEATHER_ICONS_LOCALSTORAGE_KEY,
        false, // Default is disabled
      ) === 'true'
    );
  }

  initAnimatedWeatherIcons() {
    const enabled = this.getAnimationEnabledStateFromLocalStorage();

    this.$animationEnabledSwitch.prop('checked', enabled);
    this.onAnimationsToggled(enabled);
  }

  onAnimationsToggled(enabled) {
    ClientStorage.setItem(ANIMATED_WEATHER_ICONS_LOCALSTORAGE_KEY, enabled);

    if (enabled) {
      this.showAnimatedWeatherIcons();
    } else {
      this.hideAnimatedWeatherIcons();
    }
  }

  onAnimatedWeatherIconVisibilityChanged(entry) {
    const { target, isIntersecting } = entry;
    const $target = $(target);
    const animationId = $target.attr('data-animation-id');

    if (!animationId) {
      return;
    }

    const lottieInstance = this.lottieInstances[animationId];
    if (!lottieInstance) {
      return;
    }

    if (isIntersecting) {
      lottieInstance.play();
    } else {
      lottieInstance.pause();
    }
  }

  getAnimatedWeatherIconSelectors() {
    const classes = ['.map-location__img--animated'];

    if (!this.isTeaser) {
      classes.push('.weather-day__img--animated');
    }

    return classes.join(', ');
  }

  getStaticWeatherIconSelectors() {
    const classes = ['.map-location__img--static'];

    if (!this.isTeaser) {
      classes.push('.weather-day__img--static');
    }

    return classes.join(', ');
  }

  showAnimatedWeatherIcons() {
    $(this.animatedWeatherIconSelectors).removeClass('h-element--hide');
    $(this.animatedWeatherIconSelectors).each((_i, el) => {
      const $el = $(el);
      const $container = $el.find('.lottie-container');
      const animationSrc = $el.attr('data-animation-src');
      const animationId = $el.attr('data-animation-id');

      if (!$container.length || !animationSrc || !animationId) {
        return;
      }

      const lottieInstance = lottie.loadAnimation({
        container: $container[0],
        renderer: 'svg',
        loop: true,
        autoplay: false,
        path: animationSrc,
      });

      this.lottieInstances[animationId] = lottieInstance;
      this.animatedWeatherIconObserver.observe($el[0]);
    });

    $(this.staticWeatherIconSelectors).addClass('h-element--hide');
  }

  hideAnimatedWeatherIcons() {
    $(this.animatedWeatherIconSelectors).addClass('h-element--hide');
    $(this.animatedWeatherIconSelectors).each((_i, el) => {
      const $el = $(el);
      this.animatedWeatherIconObserver.unobserve($el[0]);
    });

    Object.entries(this.lottieInstances).forEach(
      // eslint-disable-next-line no-unused-vars
      ([_animationId, lottieInstance]) => {
        lottieInstance.destroy();
      },
    );

    this.lottieInstances = {};

    $(this.staticWeatherIconSelectors).removeClass('h-element--hide');
  }

  // track user interaction when clicking on button
  trackDay(index) {
    triggerEvent(TRACK_INTERACTION, {
      event_type: 'click',
      event_source: 'meteo_map_home',
      event_name: 'day_selected',
      event_value: index.toString(), // number alone doesn't work out and gets not sent along.
    });
  }

  showDay(dayIndex) {
    this.trackDay(dayIndex);
    // replace day on display
    $('.meteo-locations__container').removeClass('active');
    $('#day-' + dayIndex).addClass('active');

    // change title
    let $title = $('.js-weather-title');
    let $subtitle = $('.js-weather-title-addition');
    $title.text($title.data('day-' + dayIndex));
    $subtitle.text($subtitle.data('day-' + dayIndex));
  }

  showWarnings() {
    let url = '/meteoapi/warning/count';
    $.get(url, (data) => {
      if (data.warning_count > 0) {
        $('#js-meteo-warnings--home').removeClass('h-element--hide');
      } else {
        $('#js-meteo-warnings--home').addClass('h-element--hide');
      }
    });
  }
}
